import { lazy } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import { assetMgmtListRoutes, assetMgmtRoute, assetMgmtRoutes } from "./AssetManagementRoutes";
import { ecommRoute, ecommerceRoutes, ecommmerceListRoutes } from "./EcommerceRoutes";
import { hrmMutationRoutes, hrmRoute, hrmRoutes } from "./HRMRoutes";
import { masterListRoutes, masterMutationRoute, masterRoute, masterRoutes } from "./MasterRoutes";
import { mitarSCMRoutes, mitraMutationRutes, mitraSCMRoute, mitraTabRoute } from "./MitraRoutes";
import { purchMainTabRoutes, purchaseMutationRoutes, purchaseRoute, purchaseRoutes } from "./PurchaseRoutes";
import { reportListRoutes, reportMutationRoutes, reportRoute, reportRoutes } from "./ReportRoutes";
import { salesMainTabRoutes, salesMutationRoutes, salesRoute, salesRoutes } from "./SalesRoutes";
import { scMutationRoutes, supplyChainRoute, supplyChainRoutes, supplychainListRoutes } from "./SupplychainRoutes";
// import { spalListRoutes, spalMutationRoute, spalRoute, spalRoutes } from "./SPALRoutes";
import { transListRoutes, transMutationRoutes, transRoute, transactionRoutes } from "./TransactionRoutes";
import { warehouseMutationRoutes, warehouseRoutes, warehouseTabRoutes, whsRoute } from "./WarehouseRoutes";
import { RKAMutationRoute, rkaRoute, rkaRoutes } from "./RKARoutes";
import { paymentListRoutes, paymentMutationRutes, paymentRoutes } from "./PaymentRoutes";
import { facilityListRoutes, facilityMutationRoute, facilityRoutes } from "./FacilityRoutes";
import { contractListRoutes, contractMutationRoute, contractRoutes } from "./ContractRoutes";
import { addNonePermissionRoute } from "../utils/RouteHelper";

//routes
// export const homeRoute = { path: "/", name: "Home" };
export const loginRoute = { path: "/login", name: "Login" };
export const error_404 = { path: "/404", name: "Error 404" };
export const error_403 = { path: "/403", name: "Error 403" };
export const error_500 = { path: "/500", name: "Error 500" };
export const dashboardRoute = { path: "/dashboard", name: "menu.dashboard", icon: "dashboard" };
export const companyProfileRoute = { path: "/company_profile", name: "company_profile." };

// component
const Login = lazy(() => import("../page/login/Login"));
const MainLayout = lazy(() => import("../layouts/MainLayout"));
const Error_404 = lazy(() => import("../page/error/Error404"));
const Error_403 = lazy(() => import("../page/error/Error403"));
const Error_500 = lazy(() => import("../page/error/Error500"));
const Dashboard = lazy(() => import("../page/dashboard/Dashboard"));
const CompanyProfile = lazy(() => import("../page/company_profile/CompanyProfile"));

// breadcrum
const BreadcrumbRouteList = [
  dashboardRoute,
  companyProfileRoute,
  ...[assetMgmtRoute, ...assetMgmtListRoutes],
  ...[ecommRoute, ...ecommmerceListRoutes],
  ...[hrmRoute, ...hrmMutationRoutes],
  ...[masterRoute, ...masterListRoutes, ...masterMutationRoute],
  ...[mitraSCMRoute, ...mitraTabRoute, ...mitraMutationRutes],
  ...[purchaseRoute, ...purchMainTabRoutes, ...purchaseMutationRoutes],
  ...[...paymentListRoutes, ...paymentMutationRutes],
  ...[reportRoute, ...reportListRoutes, ...reportMutationRoutes],
  ...[salesRoute, ...salesMainTabRoutes, ...salesMutationRoutes],
  // ...[spalRoute, ...spalListRoutes, ...spalMutationRoute],
  ...[supplyChainRoute, ...supplychainListRoutes, ...scMutationRoutes],
  ...[transRoute, ...transListRoutes, ...transMutationRoutes],
  ...[whsRoute, ...warehouseTabRoutes, ...warehouseMutationRoutes],
  ...[rkaRoute, ...RKAMutationRoute],
  ...[...facilityListRoutes, ...facilityMutationRoute],
  ...[...contractListRoutes, ...contractMutationRoute],
];

// main
const nonePermissionRoute = addNonePermissionRoute([
  { path: "*", element: <Navigate to={error_404.path} replace />, },
  { path: "/", element: <Navigate to={dashboardRoute.path} replace />, },
  { ...dashboardRoute, element: <Dashboard /> },
  { ...companyProfileRoute, element: <CompanyProfile /> },
]);

const routes = createBrowserRouter(
  [
    { ...loginRoute, element: <Login /> },
    { ...error_404, element: <Error_404 /> },
    { ...error_403, element: <Error_403 /> },
    { ...error_500, element: <Error_500 /> },
    {
      element: <MainLayout />,
      children: [
        ...nonePermissionRoute,
        { ...assetMgmtRoute, element: <Navigate to={dashboardRoute.path} replace /> },
        { ...masterRoute, element: <Navigate to={dashboardRoute.path} replace /> },
        { ...mitraSCMRoute, element: <Navigate to={dashboardRoute.path} replace /> },
        { ...purchaseRoute, element: <Navigate to={dashboardRoute.path} replace /> },
        { ...reportRoute, element: <Navigate to={dashboardRoute.path} replace /> },
        { ...salesRoute, element: <Navigate to={dashboardRoute.path} replace /> },
        { ...supplyChainRoute, element: <Navigate to={dashboardRoute.path} replace /> },
        { ...transRoute, element: <Navigate to={dashboardRoute.path} replace /> },
        { ...whsRoute, element: <Navigate to={dashboardRoute.path} replace /> },
        ...mitarSCMRoutes,
        assetMgmtRoutes,
        ecommerceRoutes,
        masterRoutes,
        purchaseRoutes,
        paymentRoutes,
        reportRoutes,
        salesRoutes,
        supplyChainRoutes,
        transactionRoutes,
        warehouseRoutes,
        rkaRoutes,
        facilityRoutes,
        contractRoutes,
        // { ...ecommRoute, element: <Navigate to={dashboardRoute.path} replace /> },
        // { ...homeRoute, element: <Navigate to={dashboardRoute.path} replace /> },
        // { ...hrmRoute, element: <Navigate to={dashboardRoute.path} replace /> },
        // { ...spalRoute, element: <Navigate to={dashboardRoute.path} replace /> },
        // ...hrmRoutes,
        // spalRoutes,
      ],
    },
  ],
  { future: { v7_normalizeFormMethod: true } }
);

export default routes;
export { BreadcrumbRouteList };
// end main
